module.exports = __webpack_public_path__ + "media/styles/images/svg/upload-overlay-teal-3b5c8a57e10cf133754d3c35061a0145.svg";